import { render, staticRenderFns } from "./patents_tab.vue?vue&type=template&id=29d5827d"
import script from "./patents_tab.vue?vue&type=script&lang=js"
export * from "./patents_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports